import React from 'react';
import './App.css';
import images from './images.js';
import { Link, Redirect } from 'react-router-dom';
import Helmet from 'react-helmet'
import Checkbox from 'rc-checkbox';
import './Checkbox.css';
import ImageFadeIn from "react-image-fade-in"
import searchAddons from './search-addons.js'
import useTmdb from './useTmdb.js'

function imageResize(posterUrl, width) {
  if (!posterUrl) return null
  if (!posterUrl.includes('amazon.com') && !posterUrl.includes('imdb.com')) return posterUrl
  if (posterUrl.includes('._V1_.')) posterUrl = posterUrl.replace('._V1_.', '._V1_SX' + width + '.')
  else if (posterUrl.includes('._V1_')) {
    var extension = posterUrl.split('.').pop()
    posterUrl = posterUrl.substr(0,posterUrl.indexOf('._V1_')) + '._V1_SX' + width + '.' + extension
  }
  return posterUrl
}

export default class App extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
        addonManager: false,
        update: 1
      };
  }
  componentWillMount() {

      const isRefresh = localStorage.getItem('lastKnownUrl') === window.location.pathname + window.location.search

      if (isRefresh) {
        setTimeout(() => {
          window.scrollTo(0,0)
        },100)
      }

      localStorage.setItem('lastKnownUrl', window.location.pathname + window.location.search)

      const processMeta = data => {

	let isOther = false

	if ((data.genres || []).length) {
		if (data.genres.some(el => ['Game-Show', 'Reality-TV', 'News', 'Talk-Show'].includes(el))) {
			isOther = true
		}
		if (data.genres.length === 1 && data.genres.includes('Sport')) {
			isOther = true
		}
	}

        const lists = require('./data/lists.json')
        let releaseInfo = lists[isOther ? 'other' : data.type][imdbId]
	if (!releaseInfo && !isOther && lists['other'][imdbId])
		releaseInfo = lists['other'][imdbId]
  //      delete releaseInfo.meta
        data.releaseInfo = releaseInfo || {}
  //      console.log(data)

        if (!(window.localStorage || {}).addons)
          window.localStorage.addons = JSON.stringify(['JustWatch'])

        if (!(window.localStorage || {}).watchlist)
          window.localStorage.watchlist = JSON.stringify({ movie: {}, series: {}, other: {}, movieWatchlistOrder: [], seriesWatchlistOrder: [], otherWatchlistOrder: [] })

        const isAndroid = ((window.navigator || {}).userAgent || '').endsWith('AndroidApp')

        this.setState({ initLoading: false, item: data, isOther, isAndroid })
      }

      let locTypes = this.props.location.pathname.split('/')
      const imdbId = locTypes[locTypes.length -1]
      try {
        const data = require('./data/meta/' + imdbId + '.json')
        processMeta(data)
      } catch(e) {
        this.setState({ initLoading: true })
        fetch('https://api.torrent-track.app/meta/' + imdbId + '.json')
          .then(res => res.json())
          .then(
            (result) => {
              processMeta(result)
            },
            (error) => {
              this.setState({ initLoading: false })
              // maybe handle errors in the future
            }
          )
      }
  }
  pageTitle() {
     let docTitle = ''

     if (this.state.item.name)
        docTitle += this.state.item.name

      if (this.state.item.year)
        docTitle += ' ' + this.state.item.year

      return docTitle
  }
  pageDescription() {
    let docDesc = ''

    if (this.state.item.name)
      docDesc += this.state.item.name

    if (this.state.item.year)
      docDesc += ' ' + this.state.item.year

    docDesc += ' torrent releases, includes IMDB, Metacritic, Rotten Tomatoes scores and reviews.'

    return docDesc
  }
  showAddonManager() {
    this.setState({
      addonManager: true
    })
  }
  addonChange(a,e) {
    const addonName = a
    const checked = ((e || {}).target || {}).checked
    const addons = JSON.parse(window.localStorage.addons)
    if (!checked)
      addons.splice(addons.indexOf(addonName), 1)
    else
      addons.push(addonName)
    window.localStorage.addons = JSON.stringify(addons)
  }
  saveAddons() {
    this.setState({ addonManager: false })
  }
  addToWatchlist() {
    const watchlist = JSON.parse(window.localStorage.watchlist)
    if (!((this.state.item || {}).ids || {}).imdb || !((this.state.item || {}).type))
      return
    const watchlistType = this.state.isOther ? 'other' : this.state.item.type
    watchlist[watchlistType + 'WatchlistOrder'].unshift(this.state.item.ids.imdb)
    watchlist[watchlistType][this.state.item.ids.imdb] = this.state.item.releaseInfo
    window.localStorage.watchlist = JSON.stringify(watchlist)
    this.setState({ update: this.state.update+1 })
  }
  removeFromWatchlist() {
    const watchlist = JSON.parse(window.localStorage.watchlist)
    const watchlistType = this.state.isOther ? 'other' : this.state.item.type
    if ((watchlist[watchlistType + 'WatchlistOrder'] || []).includes(((this.state.item || {}).ids || {}).imdb || ''))
      watchlist[watchlistType + 'WatchlistOrder'].splice(watchlist[watchlistType + 'WatchlistOrder'].indexOf(this.state.item.ids.imdb), 1)
    delete watchlist[watchlistType][this.state.item.ids.imdb]
    window.localStorage.watchlist = JSON.stringify(watchlist)
    this.setState({ update: this.state.update+1 })
  }
  agreedLegal() {
    window.localStorage.agreedLegal = '1'
    this.setState({ agreedLegal: true })
  }
  render() {
    if (this.state.initLoading) {
      return (
        <div className="loading">
          <div />
          <div />
        </div>
      )
    }
    const addons = JSON.parse(window.localStorage.addons)
    const watchlist = JSON.parse(window.localStorage.watchlist)

    const data = this.state.item

    if (!data || !Object.keys(data).length) {
     let locTypes = this.props.location.pathname.split('/')
     const imdbId = locTypes[locTypes.length -1]
     if ((imdbId || '').startsWith('tt')) {
      return (
        <>
          <center>
            <div style={{ margin: '30px', marginTop: '50px' }}>This item is no longer available, see it on <a className="blank-link" style={{ textDecoration: 'underline' }} href={"https://imdb.com/title/" + imdbId + "/"} target="_blank">IMDB</a>.</div>
            <Link className={'main-links'} style={{ margin: '0', marginTop: '20px' }} to={'/movies/'}>Go home</Link>
          </center>
        </>
      )
     } else {
       return <Redirect to={'/404'} />
     }
    }

    let ratings = { __html: '' }
    if ((((data.ratings || {}).imdb || {}).audience || {}).score) {
      ratings.__html += '<div class="imdb-small" style="vertical-align: middle; margin-top: -3px"></div>&nbsp;&nbsp;' + data.ratings.imdb.audience.score + '/10'
    }
    if ((((data.ratings || {}).metacritic || {}).critics || {}).score) {
      if (ratings.__html)
        ratings.__html += '&nbsp;&nbsp;&nbsp;&nbsp;'
      ratings.__html += '<div class="mc-small" style="vertical-align: middle; margin-top: -3px"></div>&nbsp;&nbsp;' + data.ratings.metacritic.critics.score + '%'
    }
    if ((((data.ratings || {}).rt || {}).critics || {}).score) {
      if (ratings.__html)
        ratings.__html += '&nbsp;&nbsp;&nbsp;&nbsp;'
      ratings.__html += '<div class="tomato-small" style="vertical-align: middle; margin-top: -3px"></div>&nbsp;&nbsp;' + data.ratings.rt.critics.score + '%'
    }
    if (!ratings.__html)
      ratings.__html = '&nbsp;'

    const genres = { __html: (data.genres || []).length ? data.genres.join(' / ') : '&nbsp;' }

    const searchers = searchAddons.map((el, ij) => {
      if (!addons.includes(el.name))
        return ('')
      let query = data.name
      if (el.alphanumeric)
        query = query.replace(/[^\w\s]/gi, '').trim()
      if (el.noQuotes)
        query = query.split("'").join('').split('"').join('')
      if (data.type === 'movie')
        query += ' ' + data.year
      let url = el.url
      if (el.useIds && el.useIds.length) {
        let missingId = false
        el.useIds.forEach(thisId => {
          if ((data.ids || {})[thisId]) {
            url = url.replace('%%' + thisId + '%%', data.ids[thisId])
          } else
            missingId = true
        })
        if (missingId)
          return ('')
      }
      if (Object.keys(el.types || {}).length) {
        if (el.types[data.type])
          url = url.replace('%%type%%', el.types[data.type])
        else
          return ('')
      }
      if (el.url.includes('%%query'))
        url = url.replace('%%query%%', encodeURIComponent(query).split('%20').join(el.space || '%20'))
      return (
        <a key={'searcher-' + ij} style={{ marginBottom: '15px' }} className={'main-links'} href={url} target="_blank" rel="noopener noreferrer">{el.name}</a>
      )
    })

    searchers.push((
        <span key={'searcher-99'} onClick={this.showAddonManager.bind(this)} style={{ marginBottom: '15px', padding: '10px 15px', height: '21px', verticalAlign: 'top' }} className={'main-links'}>
          +
        </span>
      ))

    let releases = []
    let lastRelease = false
    let lastEpisode = []

    if (Object.keys(data.releaseInfo).length) {
      releases = data.releaseInfo.tags.filter(el => !!el).map((el, ij) => {
        return (
          <span key={'release-' + ij} style={{ padding: '5px', backgroundColor: 'rgba(255,255,255,0.1)', marginRight: '10px', marginTop: '11px', display: 'inline-block' }}>
            {el}
          </span>
        )
      })

      lastRelease = new Date(data.releaseInfo.pubdate).toLocaleDateString("en-US")

      lastEpisode = (<br/>)

      if (data.type === 'series') {
        let episodeTag = ''
        if (((data.releaseInfo || {}).episode_info || {}).seasonnum)
          episodeTag += 'S' + ('0' + data.releaseInfo.episode_info.seasonnum).slice(-2)
        if (((data.releaseInfo || {}).episode_info || {}).epnum && data.releaseInfo.episode_info.epnum !== "1000000")
          episodeTag += 'E' + ('0' + data.releaseInfo.episode_info.epnum).slice(-2)
        if (episodeTag)
          lastEpisode = (
            <div>
              <br/>
              Last episode:<div style={{ width: '10px', display: 'inline-block' }}/><span style={{ padding: '5px', backgroundColor: 'rgba(255,255,255,0.1)', marginRight: '10px' }}>{episodeTag}</span>
            </div>
          )
      }
    }
    let actors = ('')

    if ((data.cast || []).length) {
      actors = data.cast.slice(0,4).map((el, ij) => {
        let character = ('')
        if ((el.characters || [])[0])
          character = (
            <div>
              <div style={{ height: '10px' }}/>
              <span style={{ opacity: '0.7', fontSize: '15px' }}>{el.characters[0]}</span>
            </div>
          )
        let actorImage = (
          <div className="actor-image-background">
            <div style={{ width: '200px', height: '296px', backgroundColor: 'rgba(255,255,255,0.1)' }}/>
          </div>
        )
        if (el.image)
          actorImage = (
              <div className="actor-image-background">
                <div style={{ width: '200px', height: '296px' }}>
                  <ImageFadeIn src={imageResize(el.image, 400)} alt={el.name} width={200} style={{ objectFit: 'cover', width: '100%', height: '100%'}}/>
                </div>
              </div>
          )
        return (
          <a className="blank-link" key={'actor-' + ij} href={'https://imdb.com' + el.ids.imdb} target="_blank" rel="noopener noreferrer">
            <div className="actor-block">
              {actorImage}
              <br/>
              {el.name}
              {character}
            </div>
          </a>
        )
      })
    }

    let stills = ('')

    if ((data.stills || []).length) {
      stills = data.stills.slice(0,3).map((el, ij) => {
        return (
          <a className="still blank-link" key={'still-' + ij} href={el.url} target="_blank" rel="noopener noreferrer" style={{ marginRight: ij === 2 ? '0px' : '20px' }}>
            <ImageFadeIn src={imageResize(el.url, 500)} alt={data.name + ' still'} style={{ marginBottom: '15px' }}/>
          </a>
        )
      })
    }

    let reviews = []

    function mapReviews(el) {
        return (
          <div style={{ padding: '14px', marginBottom: '15px', backgroundColor: 'rgba(255,255,255,0.1)' }}>
            <span style={{ fontSize: '15px', opacity: '0.7' }}>{((el.critic || {}).name || 'Anonymous') + ((el.publication || {}).name ? ' (' + el.publication.name + ')' : '')}</span>
            <br/><br/>
            {el.quote || ''}
          </div>
        )
    }

    let tempReviews

    if (!tempReviews && (((data.reviews || {}).metacritic || []).critics || []).length)
      tempReviews = data.reviews.metacritic.critics

    if (!tempReviews && (((data.reviews || {}).rt || []).critics || []).length)
      tempReviews = data.reviews.rt.critics

    if (!tempReviews && (((data.reviews || {}).imdb || []).audience || []).length)
      tempReviews = data.reviews.imdb.audience

    if (tempReviews) {
      reviews = tempReviews.map(mapReviews)
    }

    let reviewLink = []

    if (data.consensus) {
      reviewLink.push(
          <a className={'main-links'} href="#consensus">Reviews</a>
      )
    } else if (reviews.length) {
      reviewLink.push(
          <a className={'main-links'} href="#reviews">Reviews</a>
      )
    }

    let mainLinks = []

    if ((((data.trailers || {}).youtube || [])[0] || {}).url) {
      const mainButton = (
        <>
          <a className={'main-links'} href={data.trailers.youtube[0].url} target="_blank" rel="noopener noreferrer">Trailer</a>
        </>
      )
      mainLinks.push(mainButton)
    }

    if (reviewLink.length) {
      const mainButton = (
          <>
            { reviewLink.length ? reviewLink : '' }
          </>
        )

      mainLinks.push(mainButton)
    }

    let watchlistButton = (
      <>
        <span className={'main-links'} onClick={this.addToWatchlist.bind(this)}>+ Watchlist</span>
      </>
    )

    if ((watchlist[(this.state.isOther ? 'other' : data.type) + 'WatchlistOrder'] || []).includes(((data || {}).ids || {}).imdb || '')) {
      watchlistButton = (
        <>
          <span className={'main-links'} onClick={this.removeFromWatchlist.bind(this)} style={{ border: '1px solid rgba(255,255,255,0.3)' }}>- Watchlist</span>
        </>
      )
    }

    mainLinks.push(watchlistButton)

    let externalLinks = []

    if (data.ids.imdbUrl)
      externalLinks.push(
        <a key="imdb-link" className={'extra-links'} href={'https://imdb.com' + data.ids.imdbUrl} target="_blank" rel="noopener noreferrer">IMDB</a>
      )

    if (data.ids.metacritic)
      externalLinks.push(
        <a key="mc-link" className={'extra-links'} href={'https://metacritic.com' + data.ids.metacritic} target="_blank" rel="noopener noreferrer">Metacritic</a>
      )

    if (data.ids.rtUrl)
      externalLinks.push(
        <a key="rt-link" className={'extra-links'} href={'https://rottentomatoes.com' + data.ids.rtUrl} target="_blank" rel="noopener noreferrer">Rotten Tomatoes</a>
      )

    if (data.ids.homeUrl)
      externalLinks.push(
        <a key="homepage-link" className={'extra-links'} href={data.ids.homeUrl} target="_blank" rel="noopener noreferrer">Official Website</a>
      )

    let plot = ('')

    if (data.plot)
      plot = (
        <>
          <br/>
          <br/>
          {data.plot}
        </>
      )

    let addonsNotice = ('')

    if (addons.length < 2)
      addonsNotice = (
        <>
          <div style={{ marginTop: '10px' }}/>
          <span style={{ opacity: '0.7', fontSize: '15px' }}>Add more search addons by pressing the "+" button</span>
          <br/>
        </>
      )

    let addonManagerBox = ('')

    if (this.state.addonManager) {
      const addonManagerOpts = []
      searchAddons.forEach((el, ij) => {
        const newEl = (
          <label key={'addon-manager-' + ij} className="addon-label">
            <Checkbox
              defaultChecked={addons.includes(el.name)}
              onChange={this.addonChange.bind(this, el.name)}
              disabled={false}
            />
            &nbsp;&nbsp; {el.name}
          </label>
        )
        addonManagerOpts.push(newEl)
      })
      addonManagerBox = (
        <div style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px', marginTop: '20px', paddingBottom: '5px', width: 'calc(100% - 40px)' }}>
          <h3 style={{ margin: '0', fontSize: '17px' }}>Search addons</h3>
          <br/>
          {addonManagerOpts}
          <br/>
          <span onClick={this.saveAddons.bind(this)} style={{ marginBottom: '15px', marginTop: '7px' }} className={'main-links'}>
            Save
          </span>
        </div>
      )
    }

    let itemImages = []

    if (data.poster)
      itemImages.push(
        <a className="poster blank-link" href={data.poster} target="_blank" rel="noopener noreferrer">
          <ImageFadeIn src={useTmdb.forPosters.includes(data.ids.imdb) && data.tmdbPoster ? data.tmdbPoster : imageResize(data.poster, 350)} alt={data.name + ' poster'} width={'100%'} style={{ maxWidth: '100%', width: '100%' }}/>
        </a>
      )

    if (data.backdrop)
      itemImages.push(
        <a className="backdrop blank-link" href={data.backdrop} target="_blank" rel="noopener noreferrer">
          <ImageFadeIn src={imageResize(data.backdrop, 550)} alt={data.name + ' backdrop'} width={'100%'} style={{ maxWidth: '100%', width: '100%' }}/>
        </a>
      )

    let noLeftSide = false

    let noLeftSideSmall = false

    if (!ratings.__html.length || ratings.__html.length === 6) {
      if (!itemImages.length)
        noLeftSide = true
      else if (!data.backdrop)
        noLeftSideSmall = true
    }

    let metaGenres = ('')

    if ((data.genres || []).length) {
      metaGenres = (
        <div className="meta-genres">
          <br/>
          <span style={{ opacity: '0.7' }} dangerouslySetInnerHTML={genres}/>
        </div>
      )
    }

    let mainLinksSpace = (
      <>
        <div style={{ height: '25px' }} />
      </>
    )

    if (!(data.genres || []).length && !data.plot)
      mainLinksSpace = (
        <>
          <br/>
        </>
      )

    let stickyLegal = ('')

    if (!window.localStorage.agreedLegal && !this.state.isAndroid) {
      stickyLegal = (
        <div className="sticky-legal" style={{ display: 'block' }}>
          The use of this service presumes that you agree with the cookie / privacy policies, as well as the disclaimer, which can be found <Link className="blank-link" to={'/legal'} style={{ textDecoration: 'underline' }}>here</Link>.
          <div style={{ height: '15px' }}/>
          <div className="main-links" onClick={this.agreedLegal.bind(this)} style={{ fontSize: '15px', padding: '5px', marginRight: '0', marginLeft: '0'}}>I understand</div>
        </div>
      )
    }

    return (
      <div className={'App Meta'} style={{ marginTop: '60px' }}>
        <Helmet>
          <title>{this.pageTitle() + ' - Torrent Track'}</title>
          <meta
            name="description"
            content={this.pageDescription()}
          />
        </Helmet>
        <div className="expand-width">
          <div className="sticky" style={{ display: 'block', marginLeft: '-10%', height: '21px' }}>
            <div className="sticky-inner" style={{ width: '80%' }}>
              <span style={{ float: 'right'}}><Link className={'blank-link meta-watchlist-button'} to={'/watchlist'}>My watchlist</Link></span>
              <h1 style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{data.name + (data.year ? ' (' + data.year + ')' : '')}</h1>
            </div>
          </div>
          <header className="App-header">
            <br/>
            <Link className="blank-link" style={{ zIndex: '100' }} to="/">
              <img src={images.logo} className="App-logo-meta" alt="Torrent Track logo" />
            </Link>
            <br/>
          </header>
          <div className={'header-buttons-holder'}>
            <Link className={'main-links meta-movie-button'} style={{ marginBottom: '15px' }} to={'/movies/'}>Movies</Link>
            <Link className={'main-links meta-series-button'} style={{ marginRight: '0' }} to={'/series/'}>Series</Link>
          </div>
          <div className={'left-side' + (noLeftSideSmall ? ' no-left-side-small' : '')} style={{ display: noLeftSide ? 'none' : 'inline-block' }}>
            <div style={{ display: ratings.__html.length ? 'block' : 'none', fontSize: '16px', backgroundColor: 'rgba(0,0,0,0.2)', padding: '10px 0', opacity: '1' }} dangerouslySetInnerHTML={ratings}/>
            {itemImages}
          </div>
          <div className={'right-side' + (noLeftSideSmall ? ' no-left-side-right' : '')}>
            <div style={{ display: 'inline-block', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px', width: 'calc(100% - 40px)' }}>
              <h3 style={{ margin: '0', fontSize: '17px' }}>General</h3>
{ /*              <h1 style={{ display: 'inline-block', fontSize: '22px', margin: '0', padding: '0' }}>{data.name + (data.year ? ' (' + data.year + ')' : '')}</h1> */ }
              {metaGenres}
              {plot}
              {mainLinksSpace}
              {mainLinks}
            </div>
            {addonManagerBox}
            <div style={{ display: this.state.addonManager ? 'none' : 'block', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px', marginTop: '20px', paddingBottom: '5px', width: 'calc(100% - 40px)' }}>
              <h3 style={{ margin: '0', fontSize: '17px' }}>Addons</h3>
              {addonsNotice}
              <br/>
              {searchers}
            </div>
            { releases.length ?
              <div style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px', marginTop: '20px', width: 'calc(100% - 40px)' }}>
                <h3 style={{ margin: '0', fontSize: '17px' }}>Release info</h3>
                Known releases:<div style={{ width: '10px', display: 'inline-block' }}/>{releases}
                {lastEpisode}
                <br/>
                Last release: {lastRelease}
              </div>
              : null
            }
          </div>
          <br/>
          <div style={{ display: !(data.writers || []).length && !(data.directors || []).length ? 'none' : 'inline-block', verticalAlign: 'top', textAlign: 'left', width: 'calc(100% - 40px)', maxWidth: '100%', marginTop: '20px', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px', paddingBottom: '5px' }}>
            <div style={{ display: !data.channel ? 'none' : 'inline-block', marginRight: '30px', marginBottom: '15px' }}>
              <b>Channel</b>
              <div style={{ height: '15px'}}/>
              {data.channel}
            </div>
            <div style={{ display: !(data.directors || []).length ? 'none' : 'inline-block', marginRight: '30px', marginBottom: '15px' }}>
              <b>Directors</b>
              <div style={{ height: '15px'}}/>
              {(data.directors || []).slice(0, 2).map(el=>el.name).join(', ')}
            </div>
            <div style={{ display: !(data.writers || []).length ? 'none' : 'inline-block', marginRight: '30px', marginBottom: '15px' }}>
              <b>Writers</b>
              <div style={{ height: '15px'}}/>
              {(data.writers || []).slice(0, 2).map(el=>el.name).join(', ')}
            </div>
            <div style={{ display: !data.runtime ? 'none' : 'inline-block', marginRight: '30px', marginBottom: '15px' }}>
              <b>Runtime</b>
              <div style={{ height: '15px'}}/>
              {data.runtime} min
            </div>
          </div>
          <div className="actors-holder" style={{ display: !actors.length ? 'none' : 'inline-block', verticalAlign: 'top', textAlign: 'left', width: 'calc(100% - 40px)', maxWidth: '100%', marginTop: '20px', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px', paddingBottom: '0' }}>
              <div style={{ textAlign: 'left' }}>
                <h3 style={{ margin: '0', fontSize: '17px' }}>Cast</h3>
              </div>
              <br/>
              {actors}
          </div>
          <div style={{ display: !stills.length ? 'none' : 'inline-block', verticalAlign: 'top', textAlign: 'left', width: 'calc(100% - 40px)', maxWidth: '100%', marginTop: '20px', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px', paddingBottom: '5px' }}>
              <h3 style={{ margin: '0', fontSize: '17px' }}>Stills</h3>
              <br/>
              <div className="stills-holder">
                {stills}
              </div>
          </div>
          <div>
            <a id="consensus" style={{ position: 'relative', top: '-61px' }}/>
            <div style={{ display: !data.consensus ? 'none' : 'inline-block', verticalAlign: 'top', textAlign: 'left', width: 'calc(100% - 40px)', maxWidth: '100%', marginTop: '20px', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px' }}>
                <h3 style={{ margin: '0', fontSize: '17px' }}>Critics Consensus</h3>
                <br/>
                {data.consensus}
            </div>
          </div>
          <div>
            <a id="reviews" style={{ position: 'relative', top: '-61px' }}/>
            <div style={{ display: !reviews.length ? 'none' : 'inline-block', verticalAlign: 'top', textAlign: 'left', width: 'calc(100% - 40px)', maxWidth: '100%', marginTop: '20px', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px', paddingBottom: '5px' }}>
                <h3 style={{ margin: '0', fontSize: '17px' }}>Reviews</h3>
                <br/>
                {reviews}
            </div>
          </div>
{/*
          <div style={{ display: !externalLinks.length ? 'none' : 'inline-block', verticalAlign: 'top', textAlign: 'left', width: 'calc(100% - 40px)', maxWidth: '100%', marginTop: '20px', backgroundColor: 'rgba(0, 0, 0, 0.2)', padding: '20px', paddingBottom: '5px' }}>
              <h3 style={{ margin: '0', fontSize: '17px' }}>Links</h3>
              <br/>
              {externalLinks}
          </div>
*/}
          <div style={{ height: '50px' }}/>
        </div>
        <div className="footer">
          <ul>
            <li>
              <Link className={('blank-link meta-watchlist-button')} rel="noopener noreferrer" to={'/legal'} style={{ fontSize: '16px', opacity: '0.9' }}>Legal</Link>
            </li>
            <li>
              <Link className={('blank-link meta-watchlist-button')} rel="noopener noreferrer" to={'/api-docs'} style={{ fontSize: '16px', opacity: '0.9' }}>API</Link>
            </li>
            <li>
              <a className={('blank-link meta-watchlist-button')} rel="noopener noreferrer" href="https://powder.media/donate" target="_blank" style={{ fontSize: '16px', opacity: '0.9' }}>Donate</a>
            </li>
            <li>
              <a className={('blank-link meta-watchlist-button')} rel="noopener noreferrer" href="https://powder.media/" target="_blank" style={{ fontSize: '16px', opacity: '0.9' }}>Stream torrents</a>
            </li>
          </ul>
        </div>
        {stickyLegal}
      </div>
    );
  }
}
